"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CalendarCommonUtilities {
    static findWhere(arrayObj, identProp, ident) {
        for (let i = 0; i < arrayObj.length; i++) {
            if (arrayObj[i][identProp] && arrayObj[i][identProp] === ident) {
                return i;
            }
        }
        return -1;
    }
}
exports.default = CalendarCommonUtilities;
